import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BaseUrl } from "../../../helper/BaseUrl";
import BreadCrumb from "../../../components/BreadCrumb";

export default function ProductDetails({ initialData }) {
    const { slug } = useParams();
    const [aiData, setAiData] = React.useState(initialData?.detailpage || []);
    const navigate = useNavigate();
    const aifetcher = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/products/${slug}`, {
                method: 'GET',
            });
            const result = await response.json();
            if (result.products === false) {
                navigate("/404");
                throw new Error(`API error: ${result.message}`);
            }
            setAiData(result.products || []);
        } catch (error) {
            console.error('Fetch error:', error.message);
        }
    };
    React.useEffect(() => {
        aifetcher();
    }, [slug])



    return (
        <>
            <section className="product-grid-section">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        {aiData?.length > 0 && (
                            <div className="col-lg-9 col-md-12 mx-auto">
                                <ul className="dynamic-breadcrumb">
                                    <li> <Link to={"/"}> Home</Link></li>
                                    {/* <li> <Link to={"/product-listing"}> Our Product</Link></li> */}
                                    <li> <Link>{aiData[0]?.category_name}</Link> </li>
                                </ul>
                                <div className="choose-text">
                                    <>
                                        <h1 className="heading " >{aiData[0]?.category_name}</h1>
                                        <p>{aiData[0]?.category_brief}</p>
                                    </>

                                </div>
                            </div>
                        )}

                        {aiData?.length > 0 ? (
                            aiData.map((products, index) => (
                                <div className="col-lg-12 col-md-12 " key={index}>
                                    <div className="product-grid-card" >
                                        <div className="product-left">
                                            <div className="img-box">
                                                <img src={products?.thumbnail ? `${BaseUrl}${products.thumbnail}` : undefined} className="img-responsive" alt={products?.alt_thumbnail} />
                                            </div>
                                        </div>
                                        <div className="product-right">
                                            <div className="content-box">
                                                <div className="heading">{products?.title}</div>
                                                <p >{products?.brief}</p>
                                                {products?.brand && <div className="brand-text"><strong>Brand : </strong> {products?.brand}</div>}
                                                {products?.capacity && <div className="brand-text"><strong>Capacity : </strong> {products?.capacity}</div>}
                                                {products?.no_of_rolls_and_roll_dia && <div className="brand-text"><strong>No of Rolls & Roll Dia : </strong> {products?.no_of_rolls_and_roll_dia}</div>}
                                                {products?.type && <div className="brand-text"><strong>Type : </strong> {products?.type}</div>}
                                                <div className="btn-box">
                                                    <Link className="default-btn" to={`/product/${products?.slug}`}><span >Learn More</span> </Link>
                                                    {/* <a className="default-btn white-btn" target="_blank" href={`${BaseUrl}${products?.pdf_brochure}`} download> <span >Download brochure</span> </a> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="row justify-content-center">
                                <div className="col-md-12 col-lg-10">
                                    <div className="product-not-found">
                                        <h2 className="heading">Product Not Found</h2>
                                        <p>Sorry, the product you are looking for is not available at the moment. Please check other products.</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}

